import React from 'react'
import { FormattedMessage } from 'react-intl'
import HighlightTag from '../../../components/HighlightTag'

function BetaTag() {
  return (
    <HighlightTag>
      <FormattedMessage id="GENERAL.BETA" />
    </HighlightTag>
  )
}

export default BetaTag
